import { CHARGE_CARD } from '../../constants/actions/payment';

export function chargeCard() {
    return {
        type: CHARGE_CARD,
    };
}
